module.exports = __webpack_public_path__ + "static/media/logo.a5bf9052.svg";